export const API_ENDPOINTS = {
    SESSION: {
        START: 'v1/session/initiate',
        INSTANT_AUDIO: 'v1/audio/upload',
        AUDIO_FILE: 'v1/session/logout',
        REGISTER: 'v1/session/register',
        VIDEO_RECORD: 'v1/session/me',
        CONTENT: "v1/session/content/:sessionId",
        USAGE_CARD: "/v1/session/:sessionId/usage/cards",
        USAGE_LIST: "/v1/session/:sessionId/usage",
        RAW_FILE: 'v1/audio/upload/raw',
        DELETE: 'v1/session/:sessionId',
        ALL: '/v1/session/all',
        BOOKMARK: '/v1/session/:sessionId/bookmark',
    },
    EXPORT: {
        ALL: '/v1/session/export/:sessionId',
    },
    VIDEO: {
        SCREEN_UPLOAD: "/v1/video/upload/screen",
    },
    NOTIFICATIONS: {
        LIST: '/v1/notification/all',
        READ: '/v1/notification/:id/read',
        READ_ALL: '/v1/notification/read-all'
    },
    PROFILE: {
        ME: "v1/user/me",
        USAGE: "v1/user/usage",
        SUBSCRIPTION: "v1/user/subscription"
    },
    PAYMENT:{
        CREATE: "v1/payment",
        STATUS:"v1/payment/:orderId",
        REFUND:"v1/payment/refund/:orderId"
    },
    AUTH: {
        SOCIAL: "/auth/social-login",
        LOGIN: "/auth/login",
        REGISTER: "/auth/register"
    },
    USERS: {
        LIST: 'api/v1/users',
        CREATE: '/api/v1/users',
        VIEW: 'api/v1/users/:id',
        UPDATE: 'api/v1/users',
        PASSWORD_RESET: 'api/v1/users/:id',
        DELETE: '/api/v1/users/:id'
    }
}
